import Vue from 'vue'
import Router from 'vue-router'
import Layout from '../components/layout/Layout.vue';

Vue.use(Router);
const router = new Router({
        routes: [{
                name: 'ForgetPassword',
                path: '/forget',
                component: () =>
                    import ('../pages/forgetPassword/forget.vue')
            },
            {
                name: 'Login',
                path: '/login',
                component: () =>
                    import('../pages/login/index.vue')
            },
            {
                path: '/',
                component: Layout,
                children: [{
                    name: 'Home',
                    path: 'index',
                    component: () =>
                        import ('../pages/home/index.vue'),
                }],
            },
            {
                path: '/live',
                component: Layout,
                children: [{
                        name: 'LiveList',
                        path: 'list',
                        component: () =>
                            import ('../pages/live/liveList.vue'),
                    },
                    {
                        name: 'LiveAdd',
                        path: 'add',
                        component: () =>
                            import ('../pages/live/liveAdd.vue')
                    },
                    {
                        name: 'LiveEdit',
                        path: 'edit',
                        component: () =>
                            import ('../pages/live/liveEdit.vue')
                    },
                    {
                        name: 'LiveHistory',
                        path: 'history',
                        component: () =>
                            import ('../pages/live/history.vue')
                    },
                    {
                        name: 'ChannelShare',
                        path: 'share',
                        component: () =>
                            import ('../pages/live/channelShare.vue')
                    },
                    {
                        name: 'LiveLaunch',
                        path: 'launch',
                        component: () =>
                            import ('../pages/live/liveLaunch.vue')
                    },
                    {
                        name: 'Statistics',
                        path: 'statistics',
                        component: () =>
                            import ('../pages/live/statistics.vue')
                    },
                ],
            },
            {
                path: '/onDemand',
                component: Layout,
                children: [{
                        name: 'DemandList',
                        path: 'list',
                        component: () =>
                            import ('../pages/onDemand/demandList.vue'),
                    },
                    {
                        name: 'DemandEdit',
                        path: 'edit/:id',
                        component: () =>
                            import ('../pages/onDemand/demandEdit.vue')
                    },
                    {
                        name: 'DemandAdd',
                        path: 'add',
                        component: () =>
                            import ('../pages/onDemand/demandAdd.vue')
                    },
                    {
                        name: 'DemandFileManagement',
                        path: 'file/:id',
                        component: () =>
                            import ('../pages/onDemand/demandFileManagement.vue')
                    },
                    {
                        name: 'DemandStatistics',
                        path: 'statistics/:id',
                        component: () =>
                            import ('../pages/onDemand/demandStatistics.vue')
                    },
                    {
                        name: 'VodShare',
                        path: 'share/:id',
                        component: () =>
                            import ('../pages/onDemand/vodShare.vue')
                    },
                ],
            },
            {
                path: '/account',
                component: Layout,
                children: [{
                        name: 'Message',
                        path: 'message',
                        component: () =>
                            import ('../pages/account/messages/index.vue'),
                    },
                    {
                        name: 'Feedback',
                        path: 'feedback',
                        component: () =>
                            import ('../pages/account/feedback/index.vue')
                    },
                    {
                        name: 'AccountInfo',
                        path: 'info',
                        component: () =>
                            import ('../pages/account/accountInfo/index.vue')
                    },
                    {
                        name: 'Certification',
                        path: 'certification',
                        component: () =>
                            import ('../pages/account/certification/index.vue')
                    },
                ],
            },
            {
                path: '/finance',
                component: Layout,
                children: [{
                        name: 'Balance',
                        path: 'balance',
                        component: () =>
                            import ('../pages/finance/balance/index.vue'),
                    },
                    {
                        name: 'Recharge',
                        path: 'recharge',
                        component: () =>
                            import ('../pages/finance/recharge/index.vue'),
                    },
                    {
                        name: 'Number',
                        path: 'number',
                        component: () =>
                            import ('../pages/finance/recharge/number.vue'),
                    },
                    {
                        name: 'Pay',
                        path: 'pay',
                        component: () =>
                            import ('../pages/finance/recharge/pay.vue'),
                    },
                    {
                        name: 'Invoicing',
                        path: 'invoicing',
                        component: () =>
                            import ('../pages/finance/recharge/invoicing.vue'),
                    },
                    {
                        name: 'Deduction',
                        path: 'deduction',
                        component: () =>
                            import ('../pages/finance/deduction/index.vue'),
                    },
                    {
                        name: 'MyOrder',
                        path: 'my-order',
                        component: () =>
                            import ('../pages/finance/deduction/myOrder.vue'),
                    },
                ],
            }
        ]
    });
 router.beforeEach((to, from, next) => {
     document.title = 'Quicklive';

     next();
 });

export default router